<template>
  <div v-bind:class="
[type === 'back' ? 'krypt-stake-back':'krypt-stake-lay',
{'krypt-stake-error':alertForInput },
{'stake-input--disabled':(!marketIsActive || !runnerIsActive)&& editMode},
{'stake-input--edit-mode':editMode}
]"
       class="krypt-stake">
    <!-- <input
      v-on:change="processStake"
      v-on:blur="handleBlur"
      v-on:keydown="allowOnly2DecimalsForStake"
      @paste="allowOnly2DecimalsForStake" -->
    <input
      v-on:input="validateInput($event)"
      v-bind:class="[type === 'back' ? 'krypt-stake-back':'krypt-stake-lay']"
      class="krypt-stake-input"
      autocomplete="off"
      @focus="removeStakeMessage"
      :id="`stakeInput-${betData.refId?betData.refId:betData.id}`" :value="stakeValue"
      inputmode="decimal"
      step="any"
      type="text"
      v-focus
      >
  </div>
</template>

<script>
export default {
  name: 'kryptStakesInput',
  props: [
    'betSlipFirstTime',
    'inputSection',
    'runner',
    'betType',
    'betPosition',
    'betData',
    'event',
    'type',
    'alertId',
    'alertCase',
    'editMode'
  ],
  data: function () {
    return {
      stakeValue: '0',
      stakeTempValue: '0',

    };
  },
  watch: {
    betData: function () {
      if(this.betData.stake !=='' && !this.editMode){
        this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.betData.stake);
        this.stakeTempValue = this.betData.stake;
      } else{
        this.stakeValue = this.betData.stake;
        this.stakeTempValue = this.betData.stake;
      }

    },
    stakeValue: function (newValue, oldValue) {
      if (this.inputSection === 'betslip') {
        this.$store.commit('setStakeForBet', {
          position: this.betPosition,
          stake: newValue,
          betType: this.betData.betType
        });
      }
      if (this.inputSection === 'openBets' && this.$store.state.bets.active.betsBeingUpdated[this.betData.id]) {
        this.$store.commit('setBetBeingUpdatedStake', {
          position: this.betData.id,
          stake: newValue,
          betType: this.betData.betType
        });
        // this.$store.commit('setStakeForBet',{position:this.betPosition,stake:newValue,betType:this.betData.betType});
      }

    },
    marketIsActive: function (newValue) {
      if (!newValue) {
        document.getElementById(`stakeInput-${this.betData.refId ? this.betData.refId : this.betData.id}`)
          .blur();
      }
      ;

    },
    runnerIsActive: function (newValue) {
      if (!newValue) {
        document.getElementById(`stakeInput-${this.betData.refId ? this.betData.refId : this.betData.id}`)
          .blur();
      }
      ;
    }
  },
  mounted: function () {
    if(this.betData.stake !=='' && !this.editMode){
      this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.betData.stake);
      this.stakeTempValue = this.betData.stake;
    } else{
      this.stakeValue = this.betData.stake;
      this.stakeTempValue = this.betData.stake;
    }
  },
  methods: {
    validateInput: function (event) {

      event.currentTarget.value = this.processInputNumber(event.target.value, event.target.selectionStart);
      this.stakeValue = event.currentTarget.value
      // this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.stakeValue);
    },
    processInputNumber: function (value, selectionStart) {
      let regExp = new RegExp('(\\d{0,7})?([.|,]{1}(\\d{0,2}))?');
      let purifiedValue = value.match(regExp)[0].replace(',', '.');
      return (purifiedValue.startsWith('00') && (purifiedValue = purifiedValue.slice(2)),
      purifiedValue.startsWith('.') && selectionStart && (purifiedValue = '0' + purifiedValue),
        purifiedValue);

    },
    addBetMessage: function (runnerId, messageString) {
      this.$store.commit('addBetMessage', {
        id: runnerId,
        message: messageString
      });
    },
    removeStakeMessage: function () {
      this.$store.commit('removeStakeMessage', { id: this.betData.refId });
    },
    handleBlur: function (event) {
      this.processStake(event);
    },
    processStake: function (event) {
      if (event.currentTarget.value !== '') {
        // alert(event.key)
        let stake = this.stakeValue;
        let decimalPart = '';
        let integerPart = event.currentTarget.value.split('.')[0].replace(/\D+/g, '');
        (event.currentTarget.value.split('.')[1] ? decimalPart = event.currentTarget.value.split('.')[1] : decimalPart = '');
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        }
        this.stakeValue = `${Number(integerPart)}${decimalPart || event.key === '.' ? `.${decimalPart}` : ''}`;
        if ((this.stakeValue.length === 9 && !this.stakeValue.includes('.')) || (this.stakeValue.length === 9 && this.stakeValue.includes('.') && decimalPart === '') || (this.stakeValue.length > 9)) {
          //Uses temp value to revert
          this.stakeValue = this.stakeTempValue;
        }
        //reset last valid value
        this.stakeTempValue = this.stakeValue;
        // this.stakeValue = Number(this.stakeValue)
        // this.stakeValue = this.$options.filters.fillNumberWithZeroes(this.stakeValue);

        this.$forceUpdate();
      }

    },
    allowOnly2DecimalsForStake: function (event) {
      // this.stakeTempValue = event.currentTarget.value;
      if (event.keyCode !== 8 && event.keyCode !== 46 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39) {
        if (((event.keyCode < 96 && event.keyCode > 57 && event.keyCode !== 110) || (event.keyCode > 105 && event.keyCode !== 110) || event.keyCode === 32) && (event.keyCode === 190 || event.keyCode === 110)) {
          if (!event.ctrlKey && event.key !== '.') {
            event.preventDefault();
            return false;
          }

        } else if ((event.key === '.') && event.currentTarget.value.includes('.')) {
          event.preventDefault();
          // this.$forceUpdate()
          return false;
        }

        if (event.type === 'input' && isNaN(event.currentTarget.value)) {
          this.clearEmptyValue(event);
        }
        if ((event.currentTarget.value.length === 8 && !((event.keyCode === 190 || event.keyCode === 110)) && !event.currentTarget.value.includes('.')) || (event.currentTarget.value.length > 9)) {
          event.preventDefault();
        }
        let paste = '';
        (event.clipboardData || window.clipboardData) ? paste = (event.clipboardData || window.clipboardData)?.getData('text') : '';
        if (paste !== '' && (isNaN(paste) || paste.length > 8 || (paste.length === 9 && !paste.includes('.')))) {
          event.preventDefault();
        }
      }

    }
  },
  computed: {
    alertForInput: function () {
      return (
        this.alertId === 'noStake' ||
        this.alertId === 'liabilityTooLow'
      ) && this.marketIsActive && this.runnerIsActive;
    },
    market: function () {
      return this.$store.state.markets[this.betData.eventId]?.markets[this.betData.marketId];
    },
    marketIsActive: function () {
      return this.market ? this.market.status !== 'INACTIVE' && this.market.status !== 'SUSPENDED' : false;
    },
    betRunner: function () {
      return (this.market ? this.market.runners.find((runner) => {
        return runner.id === this.betData.runnerId;
      }) : '');
    },
    runnerIsActive: function () {
      return this.betRunner ? this.betRunner.active : false;
    },
    shouldRefocus:function () {
      return this.$store.state.bets.shouldRefocus;
    },
    newestBet: function () {
      return this.$store.state.bets.betslip.newestBet;
    },
  },
  directives: {
    focus: {
      inserted: function (el,binding,vnode) {
        if(vnode.context.betData.stake ==='' && vnode.context.shouldRefocus && vnode.context.newestBet.refId === vnode.context.betData.refId){
          setTimeout(() =>  el.focus(),100)
          vnode.context.$store.commit('setRefocus',false)
        }
      }
    }
  }
};

</script>

<style scoped>

  .krypt-stake {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 80px;
    max-width: 80px;
    background-color: var(--grey-100);
    border: solid 1px var(--grey-300);
    border-radius: 6px;
    transition: border 0.3s ease-in-out;
  }

  .krypt-stake-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    padding: 5px 0;
    font-family: "Open Sans", sans-serif !important;
    caret-color: var(--primary);
    height: 100%;
    max-height: 26px;
  }

  .view-mode .krypt-stake{
    cursor: text;
    border: solid 1px var(--grey-100);
  }

  .view-mode input {
    pointer-events: none;
  }

  .krypt-stake-input:focus {
    outline: none;
    border: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .stake-input--edit-mode:hover {
    border-color: var(--grey-400);
  }

  .krypt-stake-back:focus-within {
    border-color: var(--superman);
  }

  .krypt-stake-lay:focus-within {
    border-color: var(--lex-luthor);
  }

  .krypt-stake-error {
    border-color: var(--cyborg) !important;
  }

  .stake-input--disabled * {
    pointer-events: none;
  }

  .stake-input--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .stake-input--disabled:hover{
    border-color: var(--grey-300);
  }

  .stake-input--edit-mode{
    border: solid 1px var(--grey-300);
  }
</style>
